import { FC, useEffect } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import CountriesTable from 'components/Tables/CountriesTable';
import { countriesTranslations } from './translations';
import { CountriesTransFields } from './types';
import styles from './countries.module.scss';

const Countries: FC = () => {
  const {
    countriesStore: { setCountryData },
  } = useStore();

  useEffect(() => {
    setCountryData(null);
  }, []);

  const { t } = useMyTranslations<CountriesTransFields>([countriesTranslations.name]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{<CountriesTable />}</div>
    </main>
  );
};

export default Countries;
